// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack, BiXCircle } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const PreviewPurchaseRequisitionPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    DatePR: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];
  let user = JSON.parse(localStorage.getItem("user"));

  const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      url = url.replaceAll("/", "-");
      setTimeout(() => {
        fetch(process.env.REACT_APP_API_UPLOAD_URL + "file/" + url, {
          method: "GET", // or 'PUT'
        })
          .then((response) => response.blob())
          .then((data) => {
            const file = window.URL.createObjectURL(data);
            window.open(file);
          });
      });
    }, 2000);
  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const [isJasa, setisJasa] = useState(false);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const params = useParams();

  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisition/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/approval", formData)
  );

  const priceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonFromPRID/" + formData)
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.replaceAll("-", "/"));
      priceComparison.mutate(params.transid.replaceAll("-", "/"));
    }
    if (params.id) {
      customHandler(params.id, "BisnisUnitID");
    }
  }, []);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/approval-list");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationGet.data) {
      setDetail(mutationGet.data.data.PRList);
      blastChange(mutationGet.data.data);
      setisJasa(mutationGet.data.data.Tipe == "Jasa" ? true : false);
    }
  }, [mutationGet.status]);

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty Permintaan", key: "Qty", modifiers: "QtySatuan" },
    { name: "Qty Tersedia", key: "QtyTersedia", modifiers: "QtySatuan" },
    // Ubah dari "Qty PO" menjadi "Keterangan PO"
    // {
    //   name: "Keterangan PO",
    //   key: "KeteranganPO",
    //   modifiers: "customKeteranganPO",
    // },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "SDTDate", key: "SDTDate", modifiers: "dateOnly" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];
  const Kirim = (type) => {
    mutationUpdate.mutate({
      PurchaseRequisitionID: params.transid,
      Approved: type,
    });
  };
  // Tambahkan style untuk warna
  const keteranganStyle = (keterangan) => {
    const baseStyle = {
      fontWeight: "bold",
      padding: "4px 8px",
      borderRadius: "4px",
      display: "inline-block",
    };

    if (keterangan === "Tersedia") {
      return {
        ...baseStyle,
        backgroundColor: "#d4edda",
        color: "#155724",
      };
    } else {
      return {
        ...baseStyle,
        backgroundColor: "#f8d7da",
        color: "#721c24",
      };
    }
  };
  useEffect(() => {
    if (mutationGet.data) {
      // Enhance data dengan field yang diperlukan
      const enhancedPRList = mutationGet.data.data.PRList.map((item) => {
        const qtyPermintaan = item.Qty || 0;
        const qtyTersedia = item.QtyTersedia || 0;

        // Logika untuk menentukan Keterangan PO
        let keteranganPO = "";
        if (qtyPermintaan < qtyTersedia) {
          keteranganPO = "Tersedia";
        } else {
          keteranganPO = "Barang PO";
        }

        return {
          ...item,
          QtyTersedia: qtyTersedia,
          QtyPO: item.QtyPO || 0,
          KeteranganPO: keteranganPO, // Tambahkan field baru
        };
      });

      setDetail(enhancedPRList);
      blastChange(mutationGet.data.data);
      setisJasa(mutationGet.data.data.Tipe == "Jasa" ? true : false);
    }
  }, [mutationGet.status]);
  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate("/procurment/report/Material-and-Services-Request")
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                </div>
                {values.KeteranganTolak &&
                  values.KeteranganTolak.trim() !== "" && (
                    <div className="mx-2 mb-3 rounded-lg border border-red-300 bg-red-50 p-4">
                      <div className="flex items-center gap-2 text-red-700 font-semibold text-sm mb-1">
                        <BiXCircle className="text-lg" />
                        Purchase Requisition Ditolak
                      </div>
                      <p className="text-sm text-red-700 whitespace-pre-line">
                        <span className="font-semibold">Alasan: </span>
                        {values.KeteranganTolak}
                      </p>
                    </div>
                  )}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateLock"}
                    value={values}
                    name={"DatePR"}
                    title={"Tanggal MSR"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"TipePR"}
                    value={values}
                    name={"Tipe"}
                    title={"Tipe"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                {isJasa && values.Termin1 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin1"}
                      title={"Termin 1 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={priceComparison}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                {isJasa && values.Termin2 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin2"}
                      title={"Termin 2 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      priceComparison={priceComparison}
                      errors={errors}
                      disabled={true}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                {isJasa && values.Termin3 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin3"}
                      title={"Termin 3 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      priceComparison={priceComparison}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      isApproval={false}
                    />
                  </div>
                ) : null}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Sifat"}
                    value={values}
                    name={"Sifat"}
                    title={"Sifat Kebutuhan Barang"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Requester"}
                    title={"Requester"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Remarks"}
                    title={"Remarks"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="">
                  <div
                    className="w-full px-3"
                    onClick={() => getDataFromURL(values["NamaFile"])}
                  >
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      {values["NamaFile"] && "Ganti "}
                      Data pendukung
                    </label>
                    <label
                      htmlFor={"NamaFile"}
                      className="block w-1/4 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    >
                      {values["NamaFile"] ? (
                        <span>
                          File Selected -{" "}
                          {values["NamaFile"].name
                            ? values["NamaFile"].name
                            : values["NamaFile"]}
                        </span>
                      ) : (
                        <span>Choose a file...</span>
                      )}
                    </label>

                    <div
                      type="file"
                      id={"NamaFile"}
                      key={"NamaFile"}
                      name={"NamaFile"}
                      style={{ visibility: "hidden" }}
                      className="block  border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    />
                  </div>
                </div>
                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPurchaseRequisitionPage;
